import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import CartList from '@/components/CartList.vue';
import { onMounted } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'CartView',
  setup(__props) {

onMounted(() => {
  document.title = "Unifix Care - Cart";
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CartList))
}
}

})